import {Alert} from 'platform/components';
import {Box, Heading, Show, VStack} from 'platform/foundation';

import type {
  AdvertisementPreviewPlatform,
  GetAdvertisementPreviewApiResponse,
} from '@dms/api/sales';
import type {GetVehicleApiResponse} from '@dms/api/shared';
import i18n from '@dms/i18n';
import {SkeletonLoadingBox} from '@dms/shared';

import type {RequiredTestIdProps} from 'shared/web';

import {AdvertisementPreviewPrice} from './AdvertisementPreviewPrice';
import {AdvertisementPreviewTitleExtension} from './AdvertisementPreviewTitleExtension';

export function AdvertisementPreviewSummary(
  props: RequiredTestIdProps & {
    data: GetAdvertisementPreviewApiResponse;
    selectedPlatform?: AdvertisementPreviewPlatform;
    isDefaultLanguage: boolean;
    isLanguagePublished: boolean;
    isTextFetching: boolean;
    pricingVehicle?: GetVehicleApiResponse;
  }
) {
  return (
    <>
      <Show when={!props.isLanguagePublished}>
        <Alert
          type="inline"
          variant="info"
          title={i18n.t('page.advertisement.preview.languageNotPublished')}
          data-testid={`${props['data-testid']}-language-not-published`}
        />
      </Show>
      <Box flexGrow={0} flexShrink={0} flexBasis="auto">
        <Box data-testid={`${props['data-testid']}-ad-text`}>
          <Box flex={1}>
            <VStack spacing={2} align="stretch">
              <Heading size={1}>{props.data.title}</Heading>
              {props.isTextFetching ? (
                <Box
                  flexShrink={0}
                  data-testid={`${props['data-testid']}-title-extension-skeleton`}
                >
                  <Box width="65%">
                    <SkeletonLoadingBox isLoading height={6} />
                  </Box>
                </Box>
              ) : (
                <AdvertisementPreviewTitleExtension
                  rawValue={props.data.titleExtension}
                  selectedPlatform={props.selectedPlatform}
                  isDefaultLanguage={props.isDefaultLanguage}
                />
              )}
              <AdvertisementPreviewPrice
                selectedPlatform={props.selectedPlatform}
                pricingVehicle={props.pricingVehicle}
              />
            </VStack>
          </Box>
        </Box>
      </Box>
    </>
  );
}
